export const URL_API = process.env.REACT_APP_URL_API;
export const CLIENT_ID_GOOGLE = process.env.REACT_APP_CLIENT_ID_GOOGLE;
